import { useEffect, useState } from 'react';
import mark from '../assets/echosol-mark.png';
import { Icon } from './Icons';

const links = [
  { label: 'Our approach', href: '/#approach' },
  { label: 'Group Upp', href: '/#group-upp' },
  { label: 'About', href: '/#about' },
];

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const close = () => setMenuOpen(false);
    window.addEventListener('resize', close);
    return () => window.removeEventListener('resize', close);
  }, []);

  return (
    <header className={`site-header ${scrolled ? 'site-header--scrolled' : ''}`}>
      <div className="shell header-inner">
        <a className="wordmark" href="/#top" aria-label="Echosol Solutions home" onClick={() => setMenuOpen(false)}>
          <img src={mark} alt="" />
          <span>Echosol<span>Solutions</span></span>
        </a>

        <button
          className="menu-button"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="main-navigation"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((value) => !value)}
        >
          <Icon name={menuOpen ? 'x' : 'menu'} />
        </button>

        <nav id="main-navigation" className={menuOpen ? 'nav nav--open' : 'nav'} aria-label="Main navigation">
          {links.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)}>{link.label}</a>
          ))}
          <a className="button button--small" href="/#contact" onClick={() => setMenuOpen(false)}>
            Get in touch <Icon name="arrow" />
          </a>
        </nav>
      </div>
    </header>
  );
}
